import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const departmentsAdapter = getAdapter({ idFieldName: 'value' });

const departmentsSlice = createSlice({
  name: 'departments',
  initialState: departmentsAdapter.getInitialState(),
  reducers: {
    setDepartments: (state, { payload: { departments } }) => {
      departmentsAdapter.setAll(state, departments);
    },
  },
});

const selectors = departmentsAdapter.getSelectors(({ departments }) => departments);

export const getDepartments = (state) => selectors.selectAll(state);

export const { setDepartments } = departmentsSlice.actions;

export default departmentsSlice.reducer;
